<template>
  <div class="card">
    <headerNav title="购物车"/>
       <!-- <van-cell   class="head">
        <template slot="title">
          <van-checkbox v-model="checkedAll" @click="clickcheclall">全选</van-checkbox>
        </template>
      </van-cell> -->
    <div class="bg" :style="{width:'100%',height:'100%'}">
      <img v-if="cartList.length==0" src="../../assets/images/shopcart1.jpg" />
    </div>
    <van-checkbox-group class="card-goods" ref="checkboxGroup" v-model="checkedGoods" v-if="cartList">
      
     
      <div class="promotion-group">
        <!-- <van-cell  is-link class="head">
          <template slot="title">
            <van-checkbox v-model="checkedAll" >京东自营</van-checkbox>
          </template>
        </van-cell> -->

          <div  v-for="(item,index) in cartList"
            :key="index" class="card-goods__item">
             <van-swipe-cell> 
                <van-checkbox :name="item.id"></van-checkbox>
                <product-card :product='item' @changed="changenum" :iscard='true' @click="godetail(item)">
                  <!-- <template slot>
                    <van-cell value="修改" >
                        <template slot="title">
                            <van-tag type="danger">促销</van-tag>
                            <span class="van-cell-text" >满60元减5元</span>
                        </template>
                    </van-cell>
                  </template> -->
                </product-card>
                <template #right>
                  <van-button square text="删除" @click="delgood(item,index)" type="danger" class="delete-button" />
                </template>
             </van-swipe-cell>
          </div>
        </div>
       
    
    </van-checkbox-group>
    
    <div style="height:50px;"></div>
    <van-submit-bar
      :price="totalPrice"
      :disabled="!checkedGoods.length"
      :button-text="submitBarText"
      @submit="onSubmit"
    >
    <template slot>
      <van-checkbox v-model="checkedAll" @click="clickcheclall">全选</van-checkbox>
    </template>
    </van-submit-bar>
  </div>
</template>

<script>
import request from "../../config/ajax";
import Util from "../../config/Util";
//import appconst from "../../config/appconst";
export default {
  components: {
  },
  data() {
    return {
      checkedAll:false,
      checkedGoods: [],
      cartList:undefined,
      monOffSkus:undefined,
      oldcartList:undefined,
      // goods: [{
      //   id: '1',
      //   title: '星巴克(Starbucks)星冰乐 轻盈香草味 咖啡饮料 281ml*6瓶礼盒装低脂减糖',
      //   desc: '3.18kg/件',
      //   price: '200.00',
      //   quantity: 1,
      //   imageURL: 'https://img.yzcdn.cn/public_files/2017/10/24/2f9a36046449dafb8608e99990b3c205.jpeg',
      //   imageTag:'比加入时降5元',
      // }, {
      //   id: '2',
      //   title: '陕西蜜梨',
      //   desc: '约600g',
      //   price: '690.00',
      //   quantity: 1,
      //   imageURL: 'https://img.yzcdn.cn/public_files/2017/10/24/f6aabd6ac5521195e01e8e89ee9fc63f.jpeg',
      //     gift: [
      //       {
      //         title: "星巴克（Starbucks）星冰乐小熊吊饰星巴克（Starbucks）星冰乐小熊吊饰",
      //         quantity: 2
      //       },
      //       {
      //         title: "星巴克（Starbucks）星冰乐小熊吊饰星巴克（Starbucks）星冰乐小熊吊饰",
      //         quantity: 1
      //       }
      //     ]
      // }, {
      //   id: '3',
      //   title: '美国伽力果',
      //   desc: '约680g/3个',
      //   price: '2680.00',
      //   quantity: 1,
      //   imageURL: 'https://img.yzcdn.cn/public_files/2017/10/24/320454216bbe9e25c7651e1fa51b31fd.jpeg'
      // }]
    };
  },
  computed: {
    submitBarText() {
      const count = this.checkedGoods.length;
      return '结算' + (count ? `(${count})` : '');
    },
    totalPrice() {
      if(this.cartList)
      {
        return this.cartList.reduce((total, item) =>
        {
          var cartonSize=item.cartonSize==undefined?1:item.cartonSize;
          return  total + (this.checkedGoods.indexOf(item.id) !== -1 ? parseFloat(item.price*item.quantity*cartonSize): 0)
        }, 
        0)*100;
      }
      else
      {
        return 0;
      }
    },
  },
  watch:{
      checkedGoods(newvalue)
      {
          if(this.cartList){
            if(this.cartList.length>0){
                if(newvalue.length==this.cartList.length)
                {
                    this.checkedAll=true;
                }
                else
                {

                    this.checkedAll=false;
                }
            }
            else
            {
              this.checkedAll=false;
            }
            
          }
      },
      cartList(newvalue,oldvalue){
          console.log("监听打印修改:",oldvalue);
      }
    //  checkedGoods(newvalue,oldvalue)
    //  {
    //     if(this.cartList){
    //       if(this.cartList.length>0){
    //           if(this.cartList.length==newvalue.length){
    //             this.checkedAll=true;
    //           }
    //           else
    //           {
    //               this.checkedAll=false;
    //           }
    //       }   
    //     }
    //  }
  },
  created()
  {
    //没有登陆 让他去登录
    if (!Util.abp.session.userId) {
        this.$router.push({path:"/login/password"});
    }
    else
    {
      this.loadcartdata();
      setTimeout(()=>{
        this.initWx();
      },200)
    }
    
  },
  methods: {
    loadcartdata()
    {
        request.post('/api/services/app/PhoneCart/QueryUserCart').then(x => {
            this.cartList = x.result.cartList;
            this.oldcartList=x.result.cartList;
						this.monOffSkus = x.result.monOffSkus || [];
				})
    },
    changenum(item){
        let ids = [];
				let list = this.cartList;
				let row = item;
        let id = row.sku;
        let cartonSize=row.cartonSize;
        let quantity=row.quantity;
				ids.push(id);
				let iddto = {
					skuList: ids
        }
        
				let reqInput = {};
				reqInput.OperatorType = 0;
        reqInput.OperatorSku = id;
        reqInput.cartonSize=cartonSize;
				reqInput.Carts = this.cartList;
        this.$toast.loading({ forbidClick: true });
        //这里有问题 后续再处理 两边的赋值数据竟然一致 不限制变化数量的情况下不会有问题 
				request.post('/api/services/app/PhoneCart/CartChange', reqInput).then(x => {
					   this.oldcartList=this.cartList;
        }).catch(()=>{
            this.cartList=this.oldcartList;
        }).finally(()=>{
             this.$toast.clear();
        });
    },
    delgood(item,index){
        let ids = [];
				let list = this.cartList;
				let row = list[index];
        let id = row.sku;
        let cartonSize=row.cartonSize;
				ids.push(id);
				let iddto = {
					skuList: ids
				}
				let reqInput = {};
				reqInput.OperatorType = 1;
        reqInput.OperatorSku = id;
        reqInput.cartonSize=cartonSize;
				reqInput.Carts = this.cartList
				this.$toast.loading({ forbidClick: true });
				request.post('/api/services/app/PhoneCart/CartChange', reqInput).then(x => {
					var cc = this.cartList.filter(x => !(x.sku == id&&x.cartonSize==cartonSize));;
          this.cartList = cc;
          var ids=this.cartList.map(x=>{return x.id});
          this.checkedGoods=this.checkedGoods.filter(x=>ids.includes(x));
				}).finally(()=>{
           this.$toast.clear();
        });
    },
    onSubmit() {
      //提交订单过去
      //找出被选中的购物车
      //判断一下 只能计算一种商品类型
      
      var goodlist= this.cartList.filter(x=>this.checkedGoods.includes(x.id));
      var productType=goodlist[0].productType;
      // if(goodlist.filter(x=>x.productType==productType).length!=goodlist.length)
      // {
      //     this.$toast("大货和物料不能同时结算");
      //     return;
      // }
      if(goodlist.filter(x=>x.isSeaProduct).length>0&&goodlist.filter(x=>!x.isSeaProduct).length>0)
      {
          this.$toast("海外产品产品和非海外产品产品不能同时结算");
          return;
      }
      let page={}
      page.skus=[];
      goodlist.forEach(x => {
                page.skus.push({
                    sku: x.sku,
                    num: x.quantity,
                    cartonSize: x.cartonSize
                })
            })
this.ajax.post('/api/services/app/PhoneTrade/IsBuyer',page).then(x=>{
 localStorage.setItem("createorderinfo",JSON.stringify(goodlist));
      //params:{
      //   name:'nameValue',
      //   code:10011
      //}

      this.$router.push({name:'order',query:{createType:0}});
      //createType=0 //代表购物车
}).catch(()=>
{
  this.loadcartdata();
})
     
    },
    clickcheclall()
    {
      if(this.checkedAll)
      {
        
        this.$refs.checkboxGroup.toggleAll(true);
      }
      else
      {
        
        this.$refs.checkboxGroup.toggleAll(false);
      }
    },
    initWx() {
      //微信配置初始化
      var isIOS = !!window.navigator.userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
      let tmpurl = location.href;
      if (isIOS) {
        tmpurl = window.entryUrl;
      } else {
        tmpurl = window.location.href;
      }
      this.ajax
        .post("/api/services/app/PhoneCom/QueryH5Sign", { url: tmpurl })
        .then((y) => {
          var h5info = y.result;
          var wx = window.wx;
          wx.config({
            debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
            appId: h5info.appid, // 必填，公众号的唯一标识
            timestamp: h5info.timeStamp + "", // 必填，生成签名的时间戳
            nonceStr: h5info.nonceStr, // 必填，生成签名的随机串
            signature: h5info.sign, // 必填，签名
            jsApiList: [
              "updateAppMessageShareData",
              "updateTimelineShareData",
              "onMenuShareWeibo",
              "scanQRCode",
            ], // 必填，需要使用的JS接口列表
          });
           let link =
            "http://" +
            location.host ;
wx.ready(() => {
            wx.updateAppMessageShareData({
              title: this.abp.systemconfig.shareTitle, // 分享标题
              desc: this.abp.systemconfig.shareDesc, // 分享描述
              link: link, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
              imgUrl: this.$baseurl + this.abp.systemconfig.shareImg, // 分享图标
              success: function (res) {
                // 设置成功
              },
              fail: function (res) {
                 //alert(res);
              },
            });
            wx.updateTimelineShareData({
              title: this.abp.systemconfig.shareTitle, // 分享标题
              link: link, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
              imgUrl: this.$baseurl + this.abp.systemconfig.shareImg, // 分享图标
              success: function (res) {
                // 设置成功
              },
              fail: function (res) {
                 //alert(res);
              },
            });
          });
          wx.error(function (res) {
            //alert(res);
            // config信息验证失败会执行error函数，如签名过期导致验证失败，具体错误信息可以打开config的debug模式查看，也可以在返回的res参数中查看，对于SPA可以在这里更新签名。
          });
        });
    }
  }
};
</script>
<style lang="scss" scoped>

.card-goods {
  font-size: 12px;
  &__item {
    position: relative;
    .van-checkbox{
      width: 20px;
      height: 20px;
      top: 40px;
      left: 5px;
      z-index: 1;
      position: absolute;
    }
    .additional{
      width: 100%;
        padding-left: 15px;
    box-sizing: border-box;
    }
  }
}
.head{
      padding-left: 5px;
  border-bottom: 1px solid #eee;
}
.card{
  background: #f7f7f7;
  .van-submit-bar__bar {
      border-top: 1px solid #f7f7f7;
      .van-checkbox{
        padding-left: 5px;
      }
  }
  .promotion{
      .van-tag {
          line-height: 12px;
          margin-right: 5px;
      }
      .van-cell__title{

      flex: 4;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      }
    }
    .promotion-group{
      margin-top: 10px;
      box-shadow: 5px 5px 5px #e5e5e5;
    }
}
img
{
  width: 100%;
  height: 100%;
}

.delete-button {
  height: 100%;
}
    
</style>